import React from 'react'
import { DayPickerText } from 'src/common/components/picker'
import { useAvailability } from './Availability.hook'
import { isMobile } from 'src/helpers'
import calendarIcon from 'src/assets/icons/calendar-icon.svg'
import { EVENT_LOCATION_TYPE } from 'src/types'
import { QuizQuestionWrapper, Unserviceable } from '../../components'
import { NewLocation } from '../../components/NewFlow/NewLocation/NewLocation'
import { useLocation } from 'react-router-dom'
import { QuizType } from 'src/pages/shared'
import '../style.scss'

const disabledDays = new Date()
disabledDays.setDate(disabledDays.getDate() + 1)

export const Availability = () => {
  const query = new URLSearchParams(useLocation().search)
  const quizType = query.get('quizType') as QuizType
  const {
    loading,
    nextDisabled,
    serviceable,
    unserviceableReason,
    selectedDate,
    locationHasValue,
    locationSelected,
    handleNext,
    handleBack,
    handleServiceabilityClose,
    setSelectedDate,
    handleChange,
    handleGGPlaceSelected,
    handleBlur,
    handleFocus,
  } = useAvailability()

  return (
    <>
      <QuizQuestionWrapper
        titleStep="Getting Started"
        title="When and where are you tying the knot?"
        backAction={{
          onAction: handleBack,
        }}
        nextAction={{
          onAction: handleNext,
          disabled: nextDisabled,
        }}
        step={1}
        total={9}
        className="pinterest-flow availability-page request-a-proposal mobile-availability"
        quizType={quizType}
      >
        {!serviceable && (
          <Unserviceable unserviceableReason={unserviceableReason} handleClose={handleServiceabilityClose} />
        )}
        <div className="request-a-proposal-wrapper availability-page">
          <div className="input-wrapper for-availability mb-24px">
            <div className={`floating-label-wrapper wedding_date-date ${selectedDate ? 'has-value' : ''}`}>
              <label className="label">Wedding date</label>
              <DayPickerText
                placeholder=""
                inputProps={{
                  inputMode: 'none',
                  readOnly: isMobile,
                  name: 'weddingDate',
                  className: `input w-100`,
                  icon: <img src={calendarIcon} />,
                }}
                value={selectedDate}
                onDayChange={setSelectedDate}
                dayPickerProps={{
                  disabledDays: {
                    before: disabledDays,
                  },
                }}
                format="MM/dd/yyyy"
              />
            </div>
          </div>
          <div className="input-wrapper for-availability mb-32px">
            <div className={`floating-label-wrapper ${locationHasValue ? 'has-value' : ''}`}>
              <label className="label">Wedding location</label>
              <NewLocation
                handleChange={handleChange}
                locationSelected={locationSelected}
                handleGGPlaceSelected={handleGGPlaceSelected}
                inputProps={{ showLabel: false, onBlur: () => handleBlur(), onFocus: () => handleFocus() }}
                locationType={EVENT_LOCATION_TYPE.CEREMONY}
              />
            </div>
          </div>
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <button
              className={`check-availability-btn ${loading ? 'loading' : ''}`}
              disabled={nextDisabled || loading}
              onClick={handleNext}
            >
              Check availability
            </button>
          </div>
        </div>
      </QuizQuestionWrapper>
    </>
  )
}
